import { render, staticRenderFns } from "./OtherRestaurants.vue?vue&type=template&id=52111cd8"
import script from "./OtherRestaurants.vue?vue&type=script&lang=js"
export * from "./OtherRestaurants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports